import React, { useEffect } from 'react';
import './About.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

// <-- IMPORTANT: REPLACE WITH YOUR BEST WIDE-ANGLE HOSPITAL IMAGE
import hospitalHeroImage from './hitkari.png'; 
// <-- IMPORTANT: REPLACE WITH YOUR SECOND HOSPITAL IMAGE (INTERIOR, TEAM, OR TECHNOLOGY)
import hospitalFeatureImage from './hitkari2.jpg';


const About = () => {
    // Effect for fade-in animations
    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, { threshold: 0.1 });

        const elements = document.querySelectorAll('.animatable');
        elements.forEach(el => observer.observe(el));
        return () => elements.forEach(el => observer.unobserve(el));
    }, []);

    // Effect for the number counter animation
    useEffect(() => {
        const statsSection = document.querySelector('.stats-section-wrapper');
        const observer = new IntersectionObserver((entries, obs) => {
            const [entry] = entries;
            if (!entry.isIntersecting) return;

            const counters = document.querySelectorAll('.stat-number');
            counters.forEach(counter => {
                const target = +counter.getAttribute('data-target');
                const duration = 1500; // ms
                let start = 0;
                const stepTime = Math.abs(Math.floor(duration / target));
                const timer = setInterval(() => {
                    start += 1;
                    counter.textContent = start;
                    if (start === target) {
                        clearInterval(timer);
                        counter.textContent = counter.getAttribute('data-format') ? `${target}${counter.getAttribute('data-format')}` : target;
                    }
                }, stepTime);
            });
            obs.unobserve(statsSection);
        }, { threshold: 0.5 });

        if (statsSection) observer.observe(statsSection);
        return () => { if (statsSection) observer.unobserve(statsSection); };
    }, []);

    return (
        <>
            <div className="about-page-wrapper">
                <header className="header"><Navbar /></header>

                <main>
                    {/* HERO SECTION */}
                    <section className="about-hero" style={{ backgroundImage: `url(${hospitalHeroImage})` }}>
                        <div className="hero-content">
                            <h1 className="hero-title"><span>A Legacy of <br/>Compassionate Healthcare</span> </h1>
                            <p className="hero-subtitle">Welcome to Hitkari Hospital – Where Your Health is Our Highest Priority.</p>
                        </div>
                    </section>
                    
                    {/* INTRODUCTION SECTION */}
                    <section className="story-section">
                        <div className="container">
                            <div className="story-grid animatable">
                                <div className="story-text-content">
                                    <h2 className="section-title">Your Trusted Partner in Health</h2>
                                    <p>At Hitkari Hospital, we don’t just treat patients—we care for people. Established with a vision to provide comprehensive and compassionate healthcare to everyone, we have become a cornerstone of trust, care, and medical excellence in Balotra, Rajasthan.</p>
                                    <p><strong>Your Health, Our Priority:</strong> This guiding principle defines everything we do, focusing on making healthcare more accessible, affordable, and effective for our community.</p>
                                </div>
                                <div className="story-image-content">
                                    <img src={hospitalFeatureImage} alt="Modern Interior of Hitkari Hospital" />
                                </div>
                            </div>
                        </div>
                    </section>
                    
                    {/* WHY CHOOSE US SECTION */}
                    <section className="why-us-section">
                        <div className="container">
                            <div className="section-header animatable">
                                <h2 className="section-title-center">Why Choose Hitkari Hospital?</h2>
                                <p className="section-subtitle-center">Our commitment to excellence in every aspect of patient care.</p>
                            </div>
                            <div className="features-grid">
                                <div className="feature-card animatable" style={{ '--i': 1 }}>
                                    <div className="feature-icon"><i className="fa-solid fa-heart-pulse"></i></div>
                                    <h3>Patient-First Approach</h3>
                                    <p>Your needs are at the center of everything we do, delivered with compassion and respect.</p>
                                </div>
                                <div className="feature-card animatable" style={{ '--i': 2 }}>
                                    <div className="feature-icon"><i className="fa-solid fa-stethoscope"></i></div>
                                    <h3>Comprehensive Services</h3>
                                    <p>From general medicine to advanced surgery and specialized care, all under one roof.</p>
                                </div>
                                <div className="feature-card animatable" style={{ '--i': 3 }}>
                                    <div className="feature-icon"><i className="fa-solid fa-microscope"></i></div>
                                    <h3>Advanced Technology</h3>
                                    <p>Equipped with modern diagnostics, OTs, ICU, Laparoscopy, and more for effective treatment.</p>
                                </div>
                                <div className="feature-card animatable" style={{ '--i': 4 }}>
                                    <div className="feature-icon"><i className="fa-solid fa-user-doctor"></i></div>
                                    <h3>Skilled Professionals</h3>
                                    <p>Our experienced medical professionals collaborate to ensure you receive the best possible care.</p>
                                </div>
                                <div className="feature-card animatable" style={{ '--i': 5 }}>
                                    <div className="feature-icon"><i className="fa-solid fa-hand-holding-dollar"></i></div>
                                    <h3>Affordable Healthcare</h3>
                                    <p>With our motto “Modern Care at Moderate Cost,” quality healthcare is accessible to all.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* VISION AND MISSION */}
                    <section className="vm-section">
                        <div className="container vm-grid">
                            <div className="vm-card vision-card animatable">
                                <div className="vm-icon-wrapper"><i className="fa-solid fa-eye"></i></div>
                                <h3>Our Vision</h3>
                                <p>To redefine healthcare by offering innovative treatments, patient-centered care, and world-class medical facilities, all while ensuring that healthcare remains affordable and accessible to all.</p>
                            </div>
                            <div className="vm-card mission-card animatable">
                                <div className="vm-icon-wrapper"><i className="fa-solid fa-bullseye"></i></div>
                                <h3 style={{color:'white'}}>Our Mission</h3>
                                <p>To provide comprehensive healthcare with an unwavering commitment to patient well-being, combining cutting-edge technology with compassionate care to offer high-quality medical services.</p>
                            </div>
                        </div>
                    </section>

                    {/* STATS SECTION */}
                    <div className="stats-section-wrapper">
                        <div className="container animatable">
                             <div class="section-header">
                            <h2>Our Achievements</h2>
                            <p>Some key statistics from our work over the years.</p>
                        </div>
                            <div className="stats-grid">
                                <div className="stat-item">
                                    <h3 className="stat-number" data-target="99" data-format="%">0%</h3>
                                    <p>Patient Satisfaction</p>
                                </div>
                                <div className="stat-item">
                                    <h3 className="stat-number" data-target="800" data-format="+">0+</h3>
                                    <p>Successful Surgeries</p>
                                </div>
                                <div className="stat-item">
                                    <h3 className="stat-number" data-target="24">0</h3>
                                    <p>Years of Experience</p>
                                </div>
                                <div className="stat-item">
                                    <h3 className="stat-number" data-target="15" data-format="+">0+</h3>
                                    <p>Medical Specialities</p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    {/* SERVICES SECTION - NOW WITH FULL TEXT */}
                    <section className="services-section">
                        <div className="container">
                            <div className="section-header animatable">
                                <h2 className="section-title-center">Comprehensive Care Across All Specialties</h2>
                                <p className="section-subtitle-center">Hitkari Hospital offers an extensive range of medical services designed to meet the needs of every patient, including:</p>
                            </div>
                            <div className="services-grid">
                                <div className="service-item animatable"><span>General Medicine & Surgery</span></div>
                                <div className="service-item animatable"><span>Orthopaedics & Trauma Care</span></div>
                                <div className="service-item animatable"><span>Cardiology & Pulmonology</span></div>
                                <div className="service-item animatable"><span>Obstetrics & Gynaecology</span></div>
                                <div className="service-item animatable"><span>Paediatric Care</span></div>
                                <div className="service-item animatable"><span>Laparoscopy & Endoscopic Surgeries</span></div>
                                <div className="service-item animatable"><span>Neonatology & Geriatric Care</span></div>
                                <div className="service-item animatable"><span>Psychiatry & Rehabilitation</span></div>
                                <div className="service-item animatable"><span>Oncology & Physiotherapy</span></div>
                            </div>
                            <p className="services-conclusion animatable">
                                In addition, we provide state-of-the-art diagnostic and treatment options, including advanced imaging, laboratory services, blood bank, and intensive care units for both adults and neonates.
                            </p>
                        </div>
                    </section>

                    {/* TIMELINE SECTION (HIGH-LEVEL MILESTONES) */}
                    <section className="timeline-section">
                        <div className="container">
                            <div className="section-header animatable">
                                <h2 className="section-title-center">Our Journey of Dedication and Trust</h2>
                                <p className="section-subtitle-center">A timeline of our commitment to healthcare excellence.</p>
                            </div>
                            <div className="timeline-container">
                                <div className="timeline-item animatable">
                                    <div className="timeline-content">
                                        <h4>Our Inception & Growth</h4>
                                        <p>From a small initiative to a leading healthcare institution in the region, known for exceptional services and patient-centered care.</p>
                                    </div>
                                </div>
                                <div className="timeline-item animatable">
                                    <div className="timeline-content">
                                        <h4>Pioneering Achievements</h4>
                                        <p>Successfully performing thousands of advanced surgeries and reaching communities through extensive health programs.</p>
                                    </div>
                                </div>
                                <div className="timeline-item animatable">
                                    <div className="timeline-content">
                                        <h4>The Future of Care</h4>
                                        <p>Continuously innovating and investing in technologies like telemedicine and AI to provide the best care, now and for the future.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    
                    {/* NEW SECTION: JOURNEY DETAILS */}
                    <div className="journey-details-section">
                        <div className="detail-container">
                            <div className="details-grid">
                                <div className="detail-block success-story animatable">
                                    <h3>Our Success Story</h3>
                                    <p>Since our inception, Hitkari Hospital has grown to become one of the leading healthcare institutions in the region. What started as a small initiative to improve healthcare access in Balotra has now become a trusted name known for its exceptional services and patient-centered care.</p>
                                    <p>Over the years, we have successfully performed more than 1,000 laparoscopic surgeries, pioneered several advanced spinal and orthopedic surgeries, and treated countless patients with complex health conditions. Our community health programs and free medical camps have reached thousands of underserved individuals, making quality care accessible to everyone.</p>
                                    <p>Our journey of success is a testament to the hard work, commitment, and compassion of our medical team, as well as the trust and support we’ve received from our patients. Together, we’ve created a healthcare environment where patients come first, and the goal is always to achieve the best possible outcomes.</p>
                                </div>
                                <div className="detail-block future-vision animatable">
                                    <h3>Looking Ahead</h3>
                                    <p>As we move forward, Hitkari Hospital continues to innovate and expand, ensuring that we remain at the forefront of medical excellence. With plans to expand our services, increase bed capacity, and introduce more specialized care, we are preparing for the next chapter in our legacy.</p>
                                    <p>We are also investing in advanced technologies, including robotic surgeries, telemedicine services, and AI-powered diagnostics, ensuring that we offer the best care available now and in the future.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* NEW SECTION: FINAL CTA */}
                    <section className="final-cta-section">
                        <div className="container animatable">
                            <h2>Your Trusted Healthcare Partner</h2>
                            <p>At Hitkari Hospital, we see each patient as a person, not just a diagnosis. Our goal is to not only heal but also offer support through each step of the journey. Whether you’re seeking routine care, surgery, or life-saving treatment, you can trust us to provide expert care, cutting-edge treatments, and a compassionate environment.</p>
                            <strong>Join Us in Our Journey of Healing and Hope</strong>
                            <p>We invite you to experience healthcare as it should be— personalized, compassionate, and effective.</p>
                            <a href="/appointments" className="btn-cta">Book an Appointment</a>
                       
                        </div>
                    </section>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default About;